'use strict';

import Plyr from 'plyr';
import Swiper from 'swiper';

const $ = window.jQuery;

export default function() {
    if ( $( '.the-content' ).length <= 0 ) {
        return;
    }

    // Carousel
    if ( $( '.carousel' ).length >= 0 ) {
        const carousel = new Swiper( '.carousel', {
            loop: true,
            pagination: false,
            parallax: true,
            speed: 600,
            navigation: {
                prevEl: '.carousel-nav--prev',
                nextEl: '.carousel-nav--next',
            },
        } );
    }

    // Youtube
    if ( $( '.youtube-block' ).length >= 0 && window._axcb) {
        window._axcb.push( function( sdk ) {
            sdk.on( 'cookies:complete', function( choices ) {
                if ( choices.youtube ) {
                    $( '.youtube-block' ).each( function() {
                        const player = new Plyr( '#' + $( this ).find( '.plyr__video-embed' ).attr( 'id' ) );
                    } );
                }
            } );
        } );

        $( '[data-hide-on-vendor-consent]' ).find( 'button' ).on( 'click', function() {
            const vendor = $( this ).parent().data( 'hide-on-vendor-consent' );
            window.axeptioSDK.requestConsent( vendor );
        } );

        // Axeptio plugin deactivated case
        if ( typeof window.axeptioSettings === 'undefined' ) {
            $( '.youtube-block' ).each( function() {
                const player = new Plyr( '#' + $( this ).find( '.plyr__video-embed' ).attr( 'id' ) );
            } );
        }
    }

    // Accordion
    if ( $( '.accordion' ).length >= 0 ) {
        const $title = $( '.accordion__title' );
        const $panel = $( '.accordion__content' );

        const params = new URLSearchParams( document.location.search );
        let tabTitle = params.get( 'tab-title' );

        if ( tabTitle ) {
            var elementRecherche = $( '.accordion__title button[data-title="' + tabTitle + '"]' );

            const $sibling = $( elementRecherche[ 0 ] ).parent().siblings( '.accordion__content' );
            const $wrapper = $( elementRecherche[ 0 ] ).closest( '.accordion-wrapper' );

            $( elementRecherche[ 0 ] ).parent().parent().toggleClass( 'is-active' );
            $( elementRecherche[ 0 ] ).attr( 'aria-expanded', ( i, attr ) => attr === 'true' ? 'false' : 'true' );
            $sibling.slideToggle();

            if ( ! $wrapper.data( 'multiple' ) ) {
                $title.not( this ).parent().removeClass( 'is-active' );
                $title.not( this ).find( 'button' ).attr( 'aria-expanded', 'false' );
                $panel.not( $sibling ).slideUp();
            }

            $( 'html, body' ).animate( {
                scrollTop: $wrapper.offset().top,
            }, 1000 );
        }

        $title.on( 'click', function() {
            const $sibling = $( this ).siblings( '.accordion__content' );
            const $wrapper = $( this ).closest( '.accordion-wrapper' );

            $( this ).parent().toggleClass( 'is-active' );
            $( this ).find( 'button' ).attr( 'aria-expanded', ( i, attr ) => attr === 'true' ? 'false' : 'true' );
            $sibling.slideToggle();

            if ( ! $wrapper.data( 'multiple' ) ) {
                $title.not( this ).parent().removeClass( 'is-active' );
                $title.not( this ).find( 'button' ).attr( 'aria-expanded', 'false' );
                $panel.not( $sibling ).slideUp();
            }
        } );
    }
}
